/**
 * /pending-approval — landing page for users whose account is pending
 * admin approval (REQUIRE_USER_APPROVAL platform setting is on).
 * Reached via error-handler pivot when BE returns 403 account_pending_approval.
 */

import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { Clock } from "lucide-react";
import { LandingShell } from "@/features/system-admin/components/landing-shell";
import Button from "@/components/ui/button/Button";
import { useAuthActions, useAuthStore } from "@/stores";

export const Route = createFileRoute("/pending-approval")({
  beforeLoad: redirectApprovedAccountFromPending,
  component: PendingApprovalPage,
});

export function redirectApprovedAccountFromPending(): void {
  if (useAuthStore.getState().isAuthenticated) {
    throw redirect({ to: "/" });
  }
}

function PendingApprovalPage() {
  const t = useTranslations("system-admin.common");
  const navigate = useNavigate();
  const { logout } = useAuthActions();

  const handleLogout = async () => {
    await logout();
    navigate({ to: "/signin" });
  };

  return (
    <LandingShell
      icon={
        <div className="flex size-16 items-center justify-center rounded-2xl bg-[var(--primary)]/10 text-[var(--primary)]">
          <Clock className="size-8" aria-hidden />
        </div>
      }
      title={t("landing.pending.title")}
      description={t("landing.pending.description")}
    >
      <Button variant="outline" onClick={handleLogout} className="w-full">
        {t("landing.actions.logout")}
      </Button>
    </LandingShell>
  );
}
